<template>
  <div class="activity-container">
    <div class="leaderboard-wrapper">
      <div class="custom-header">
        <div class="options">
          <multiselect
            v-model="selected"
            deselect-label="Can't remove this value"
            track-by="name"
            label="name"
            placeholder="Activity"
            :options="activityTypes"
            :searchable="false"
            :allow-empty="false"
          ></multiselect>
          <multiselect
            v-model="selectedYear"
            deselect-label="Can't remove this value"
            track-by="name"
            label="name"
            placeholder="Year"
            :options="years"
            :searchable="false"
            :allow-empty="false"
          ></multiselect>
        </div>
      </div>
      <vue-good-table
        v-if="activityFields && leaderboard"
        :columns="activityFields.fields"
        :rows="leaderboard"
        :line-numbers="true"
        :sort-options="{
          enabled: true,
          initialSortBy: initialSortBy,
        }"
        theme="nocturnal"
      >
        <template slot="table-row" slot-scope="props">
          <span style="display: flex" v-if="props.column.field == 'athlete'">
            <div>
              <img class="profile-picture" :src="props.row.profile" />
              {{ props.row.athlete }}
            </div>
          </span>
          <span class="" v-else-if="props.column.field == 'distance'">
            <span>{{ props.row.distance }} km</span>
          </span>
          <span class="" v-else-if="props.column.field == 'avg_distance'">
            <span>{{ props.row.avg_distance }} km</span>
          </span>
          <span
            class=""
            v-else-if="props.column.field == 'avg_weekly_distance'"
          >
            <span>{{ props.row.avg_weekly_distance }} km</span>
          </span>
          <span class="" v-else-if="props.column.field == 'longest'">
            <span>{{ props.row.longest }} km</span>
          </span>
          <span class="" v-else-if="props.column.field == 'elev_gain'">
            <span>{{ props.row.elev_gain }} m</span>
          </span>
          <span class="" v-else-if="props.column.field == 'avg_speed'">
            <span>{{ props.row.avg_speed }} km/t</span>
          </span>
          <span class="" v-else-if="props.column.field == 'time'">
            {{ getTime(props.row.time) }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>


<script>
var _ = require("lodash");
import moment from "moment";

import { RepositoryFactory } from "@/repository/RepositoryFactory";
const ActivityRepository = RepositoryFactory.get("activities");
const UserRepository = RepositoryFactory.get("users");

import { activityTypes } from "@/data/activities.js";
import { secsToPace } from "@/utils/timeUtil.js";

const humanizeDuration = require("humanize-duration");
const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: "shortEn",
  languages: {
    shortEn: {
      y: () => "y",
      mo: () => "mo",
      w: () => "w",
      d: () => "d",
      h: () => "h",
      m: () => "m",
      s: () => "s",
      ms: () => "ms",
    },
  },
});

export default {
  name: "Activity",
  components: {},
  methods: {
    async fetchActivities(type, year) {
      try {
        const { data } = await ActivityRepository.get(type, year);
        return data;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchUsers() {
      try {
        // Fetching auth data from the server
        const { data } = await UserRepository.get();
        return data;
      } catch (err) {
        console.log(err);
      }
    },
    fieldFn(rowObj) {
      return secsToPace(rowObj.avg_speed);
    },
    getTime(time) {

      let timeHuman = shortEnglishHumanizer(time*1000, {
        units: ["h", "m"],
        round: true,
      });
      console.log(timeHuman)
      return timeHuman;
    },
  },
  data() {
    return {
      loading: false,
      activityTypes: activityTypes,
      users: [],
      activities: [],
      selectedYear: { name: "2023", value: 2023 },
      years: [
        { name: "2022", value: 2022 },
        { name: "2023", value: 2023 },
        { name: "All", value: "all" },
      ],
      selected: { name: "Walk", id: "walk" },
    };
  },
  created() {
    this.fetchActivities(
      this.currentActivity.value,
      this.selectedYear.value
    ).then((result) => (this.activities = result));
    this.fetchUsers().then((result) => (this.users = result));
  },
  computed: {
    activityFields() {
      return this.activityTypes.filter(
        (act) => act.id.toLowerCase() == this.selected.id.toLowerCase()
      )[0];
    },
    initialSortBy() {
      let test = this.currentActivity.fields.filter(
        (item) => item.field == "distance"
      );
      if (test.length > 0) {
        return { field: "distance", type: "desc" };
      } else {
        return { field: "time", type: "desc" };
      }
    },
    currentActivity() {
      return this.activityTypes.filter(
        (act) => act.value.toLowerCase() == this.selected.id.toLowerCase()
      )[0];
    },
    leaderboard() {
      let dataByAthlete = _.groupBy(this.activities, "athlete.id");

      let newData = [];
      Object.values(dataByAthlete).forEach((athlete) => {
        let avgPace = athlete.map((item) => item.average_pace_seconds);
        let avgSpeed = athlete.map((item) => item.average_speed);
        let maxDist = _.maxBy(athlete, "distance");

        let totalTime = Number(
          athlete
            .map((item) => item.moving_time)
            .reduce(function (previousValue, currentValue) {
              return previousValue + currentValue;
            })
            .toFixed(2)
        );
        let totalDist = Number(
          athlete
            .map((item) => item.distance / 1000)
            .reduce(function (previousValue, currentValue) {
              return previousValue + currentValue;
            })
            .toFixed(2)
        );

        let averages = {
          weekly: 0,
          monthly: 0,
          yearly: 0,
        };

        let ordered = _.orderBy(athlete, "start_date", "asc");
        var firstDay = new moment(ordered[0].start_date);
        var currDay = new moment();

        let diff = moment.duration(currDay.diff(firstDay));
        let weeksDiff =
          diff.asWeeks().toFixed(0) == 0 ? 1 : diff.asWeeks().toFixed(0);

        averages.weekly = (totalDist.toFixed(2) / weeksDiff).toFixed(2);
        averages.monthly = (
          totalDist.toFixed(2) / Math.ceil(diff.asMonths())
        ).toFixed(2);
        averages.yearly = (
          totalDist.toFixed(2) / Math.ceil(diff.asYears())
        ).toFixed(2);

        const ath = this.users.filter(
          (usr) => usr.id === athlete[0].athlete.id
        )[0];

        newData.push({
          profile: ath.profile,
          athlete: `${ath.firstname} ${ath.lastname}`,
          distance: totalDist,
          avg_distance: Number(
            _.mean(athlete.map((item) => item.distance / 1000)).toFixed(2)
          ),
          avg_weekly_distance: averages.weekly,
          elev_gain: Number(
            athlete
              .map((item) => item.total_elevation_gain)
              .reduce(function (previousValue, currentValue) {
                return previousValue + currentValue;
              })
              .toFixed(0)
          ),
          longest: Number((maxDist.distance / 1000).toFixed(2)),
          avg_pace: secsToPace(Math.round(_.mean(avgPace))),
          avg_speed: (_.mean(avgSpeed) * 3.6).toFixed(2),
          activities: athlete.length,
          time: totalTime,
        });
      });

      return newData;
    },
  },
  watch: {
    selected: function () {
      this.loading = true;
      this.fetchActivities(
        this.currentActivity.value,
        this.selectedYear.value
      ).then((result) => (this.activities = result));
      this.loading = false;
    },
    selectedYear: function () {
      this.loading = true;

      this.fetchActivities(
        this.currentActivity.value,
        this.selectedYear.value
      ).then((result) => (this.activities = result));

      this.loading = false;
    },
  },
};
</script>


<style>
.custom-header {
  min-height: 50px;
  align-items: center;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0px;
  padding: 5px;
  background-color: #262635;
}

.options {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  column-gap: 10px;
  padding: 5px;
  width: 30rem;
}

/* overrides of the vue-good-table */

td {
  vertical-align: middle !important;
  text-align: center !important;
}

.vgt-table.nocturnal {
  background-color: #313144 !important;
}

.vgt-table.nocturnal th.line-numbers,
.vgt-table.nocturnal th.vgt-checkbox-col {
  color: #c7ced8;
  border-right: 1px solid #435169;
  background: linear-gradient(#262635, #262635) !important;
}

.vgt-table.nocturnal thead th {
  color: #c7ced8;
  border-bottom: 1px solid #435169;
  background: linear-gradient(#262635, #262635) !important;
}
</style>

<style scoped>
.activity-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

h1,
h3 {
  color: #fff;
}
.selected {
  background: #e6e6e6;
}

.card-row {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  justify-content: center;
  margin-top: 25px;
}

.card-col {
  flex: 1 0 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-picture {
  border-radius: 50%;
  max-height: 50px;
  max-width: 50px;
}

.activity-tabs {
  margin-bottom: 10px;
}

.leaderboard-wrapper {
  max-width: 95vw;
  margin-bottom: 20px;
}
</style>
